// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AvatarStack_wrapper__i7Tgy","user_avatar":"AvatarStack_user_avatar__2e_i8"};